import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components/macro'
import { Normalize } from 'styled-normalize'
import { ModalProvider } from 'styled-react-modal'

import theme, { colors } from '../../constants/theme'

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600');

  html {
    background-color: ${colors.background};
  }

  body {
    font-family: 'Open Sans', sans-serif;
    color: ${colors.textNormal};
  }  
`

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>
    <ModalProvider>
      <Normalize />
      <GlobalStyle />
      {children}
    </ModalProvider>
  </ThemeProvider>
)

export default Theme
